import calendarService from "../../services/calendarService";

const state = {
  events: []
};

const getters = {
  events: state => {
    return state.events;
  }
};

const actions = {
  fetchEvents({ commit }) {
    calendarService.fetchData().then(events => {
      commit("SET_EVENTS", events);
    });
  },
  addEvent({ commit }, event) {
    calendarService.postEvent(event).then(response => {
      commit("ADD_EVENT", response);
    });
  },
  deleteEvent({ commit }, pk) {
    calendarService.deleteEvent(pk);
    commit("DELETE_EVENT", pk);
  },
  updateEvent({ commit }, event) {
    calendarService.patchEvent(event, event.pk).then(response => {
      commit("UPDATE_EVENT", response);
    });
  }
};

const mutations = {
  SET_EVENTS(state, eventData) {
    state.events = eventData;
  },
  ADD_EVENT(state, event) {
    state.events.push(event);
  },
  DELETE_EVENT(state, pk) {
    state.events = state.events.filter(obj => obj.pk !== pk);
  },
  UPDATE_EVENT(state, event) {
    state.events = state.events.filter(obj => obj.pk !== event.pk);
    state.events.push(event);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
